import React, { Component } from 'react';
import axios from 'axios';
import { Configurations } from '../../../Utils/Configurations';
import Usuario from '../../../Utils/Usuario';
import { Modal, ModalBody, ModalHeader, ModalFooter, Button } from "reactstrap";
import update from 'immutability-helper';
import ErrorModal from '../../../Components/ErrorModal/ErrorModal';
import ModalAlteracoes from '../../../Components/Modal-Alteracoes/Modal-Alteracoes';
import PodcastEpisodes from '../../../Components/Podcast-Episodes/Podcast-Episodes';
import qs from 'qs';
import Pagination from 'rc-pagination';



class PodcastProgramDetails extends Component {

    constructor(props) {
        super(props);

        this.editarEpisodio = this.editarEpisodio.bind(this);
        this.toggleModalAlteracoes = this.toggleModalAlteracoes.bind(this);
        this.novoEpisodio = this.novoEpisodio.bind(this);
        this.mudaStatusEpisodio = this.mudaStatusEpisodio.bind(this);
        this.mudaStatusPrograma = this.mudaStatusPrograma.bind(this);
        this.toggleStatusPublicacao = this.toggleStatusPublicacao.bind(this);
        this.salvarPrograma = this.salvarPrograma.bind(this);
        this.handleOnChange = this.handleOnChange.bind(this);
        this.handleError = this.handleError.bind(this);
        this.closeErrorModal = this.closeErrorModal.bind(this);
        this.voltar = this.voltar.bind(this);
        this.carregaListaEpisodios = this.carregaListaEpisodios.bind(this);
        this.refreshTableEpisodios = this.refreshTableEpisodios.bind(this);
        this.confirmaStatusPublicacao = this.confirmaStatusPublicacao.bind(this);
        this.onChangePage = this.onChangePage.bind(this);


        this.Configurations = new Configurations();

        this.state = {
            openModal: false,
            idPodcastPrograma: this.props.match.params.idPodcastPrograma,
            nomePrograma: '',
            descricaoPrograma: '',
            urlImagem: '',
            isLoadingEpisodios: false,
            isLoadingPrograma: false,
            isLoadingStatusPrograma: false,
            modalStatusPublicacao: false,
            metodoStatusPublicacao: "habilitar",
            sucessoAlteracao: false,
            temAlteracao: false,
            listaEpisodios: [],
            infosPrograma: {},
            hasError: false,
            errorMessage: '',
            modalAlteracoes: false,
            limite: 5,
            pagina: 0,
            paginasEpisodios: 1,
        }
    }

    componentDidMount() {
        this.carregaListaEpisodios();
    }
  
    mudaStatusEpisodio(status, idEpisodio) {

        const _idPodcastPrograma = this.props.match.params.idPodcastPrograma;
        const _index = this.state.listaEpisodios.findIndex(item => item.idEpsodio === idEpisodio);

        this.setState({ listaEpisodios: update(this.state.listaEpisodios, { [_index]: { loading: { $set: true } } }) })

        axios.put(this.Configurations.apiBasePath + `/podcasts/${_idPodcastPrograma}/episodios/${idEpisodio}`, { habilitado: !status })
            .then(response => {
                this.carregaListaEpisodios({ page: this.state.pagina, pageSize: this.state.limite });
            }).catch(this.handleError).finally(() => {
                this.setState({
                    listaEpisodios: update(this.state.listaEpisodios, { [_index]: { loading: { $set: false } } })
                })
            });

    }

    mudaStatusPrograma() {
        const _idPodcastPrograma = this.props.match.params.idPodcastPrograma
        axios.put(this.Configurations.apiBasePath + `/podcasts/${_idPodcastPrograma}`, { habilitado: !this.state.infosPrograma.habilitado })
            .then(response => {
                this.carregaInfosPrograma(_idPodcastPrograma);
            }).catch(this.handleError)
            .finally(() => {
                this.toggleStatusPublicacao();

            });

    }

    confirmaStatusPublicacao() {
        this.toggleStatusPublicacao();
    }

    componentWillMount() {
        let _permissoes = [1, 4, 11, 14, 20];
        const roles = Usuario.getLoggedUser.permissoes.map(item => item.numero);
        const found = roles.some(r => _permissoes.indexOf(r) >= 0);
        const foundStatistic = roles.some(r => [24].indexOf(r) >= 0);

        if (!found && !foundStatistic) {
            this.props.history.push({ pathname: '/permissao-negada' })
        } else {
            const _idPodcastPrograma = this.props.match.params.idPodcastPrograma;
            this.carregaInfosPrograma(_idPodcastPrograma)
            this.setState({ permissaoEdicaoPodcast: found })
        }
    }

    componentDidUpdate(prevProps) {
        if ((prevProps.location.search !== this.props.location.search)) {
            this.carregaListaEpisodios(this.props.match.params.idPodcastPrograma);
        }
    }

    carregaInfosPrograma(idPodcastPrograma) {
        this.setState({ isLoadingPrograma: true });
        axios.get(this.Configurations.apiBasePath + `/podcasts/${idPodcastPrograma}`).then(response => {
            this.setState({
                infosPrograma: response.data.podcastPrograma,
                nomePrograma: response.data.podcastPrograma.nome,
                descricaoPrograma: response.data.podcastPrograma.descricao,
                urlImagem: response.data.podcastPrograma.imagem
            });
        }).catch(this.handleError).finally(() => this.setState({ isLoadingPrograma: false }));
    }

    editarEpisodio(idEpisodio) {
        this.props.history.push(`/multimidia/podcasts/${this.props.match.params.idPodcastPrograma}/${idEpisodio}`)

    }

    novoEpisodio() {
        this.props.history.push(`${this.props.match.url}/novo-episodio`)
    }

    toggleModalAlteracoes() {
        this.setState({ modalAlteracoes: !this.state.modalAlteracoes })
    }

    toggleStatusPublicacao() {
        this.setState({ modalStatusPublicacao: !this.state.modalStatusPublicacao })
    }

    salvarPrograma() {
        this.setState({ isLoadingPrograma: true })
        const _idPodcastPrograma = this.props.match.params.idPodcastPrograma,
            _salvarPrograma = {
                nome: this.state.nomePrograma,
                descricao: this.state.descricaoPrograma,
                imagem: this.state.urlImagem
            };
        axios.put(this.Configurations.apiBasePath + `/podcasts/${_idPodcastPrograma}`, _salvarPrograma).then(response => {
            this.setState({ sucessoAlteracao: true, temAlteracao: false })
            this.carregaInfosPrograma(_idPodcastPrograma);
        }).catch(this.handleError).finally(() => this.setState({ isLoadingPrograma: false }));
    }

    handleOnChange(e) {
        e.preventDefault();
        const _name = e.target.name, _value = e.target.value;
        this.setState({ [_name]: _value, temAlteracao: true })
    }

    handleError(err) {
        this.setState({ hasError: true, errorMessage: err.response.data.message })
    }
    closeErrorModal() { this.setState({ hasError: false, errorMessage: "" }) }

    voltar() {
        this.state.temAlteracao ? this.toggleModalAlteracoes() : window.history.go(-1)
    }

    carregaListaEpisodios() {
        this.setState({ isLoadingEpisodios: true })
        const idPodcastPrograma = this.props.match.params.idPodcastPrograma;
        const values = qs.parse(window.location.search),
            limite = parseInt(values.limite, 10),
            pagina = parseInt(values["?pagina"], 10);
        axios.get(this.Configurations.apiBasePath + `/podcasts/${idPodcastPrograma}/episodios?page=${pagina}&pageSize=${limite}`).then(response => {
            this.setState({
                listaEpisodios: response.data.data,
                paginasEpisodios: response.data.paginacao.totalPaginas,
                limite: limite,
                pagina: pagina
            });
        }).catch(this.handleError).finally(() => this.setState({
            isLoadingEpisodios: false
        }));
    }

    refreshTableEpisodios(o) {
        this.carregaListaEpisodios(o);
    }

    inicializaParametros() {

        this.setState({
            pagina: 0,
            limite: 5,
            // pagina: 1,
            // limite: 20,
        });
    }

    onChangePage(page) {

        this.setState({
            pagina: page,
        }, () => {
            this.props.history.push({ pathname: `/multimidia/podcasts/${this.props.match.params.idPodcastPrograma}`, search: `?pagina=${this.state.pagina}&limite=${this.state.limite}` })
        });
    }
    render() {
        return (
            <div className="row episodes-list">
                <div className={`col-12`}>
                    {this.state.isLoadingEpisodios || this.state.isLoadingPrograma ? (
                        <div className="row no-gutters">
                            <div className="col-12 text-center py-5">
                                <div className="spinner-border text-primary" role="status" />
                            </div>
                        </div>
                    ) : (
                        <div className="row no-gutters">
                            <div className="col-12">
                                <div className="row no-gutters align-items-center">
                                    <div className="col-12 col-lg-8 text-center text-lg-left">
                                        <h2 className="title-1 d-none d-lg-block">Podcasts - Programa "{this.state.nomePrograma}"</h2>
                                        <h5 className="d-lg-none">{this.state.nomePrograma}</h5>
                                    </div>
                                    <div className="col-12 col-lg-4 text-center text-lg-right">
                                        <div className="row no-gutters">
                                            <div className="col py-2 py-lg-0">
                                                <button onClick={this.voltar} className="btn btn-outline-secondary">voltar</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {this.state.isLoadingPrograma ? (
                                    <div className="row no-gutters">
                                        <div className="col-12 text-center py-5">
                                            <div className="spinner-border text-primary" role="status" />
                                        </div>
                                    </div>
                                ) : (
                                    <div className="card rounded my-2">
                                        <div className="card-header">
                                            <p className="m-0">Informações do Programa</p>
                                        </div>
                                        <div className="card-body">
                                            <fieldset disabled={!this.state.permissaoEdicaoPodcast}>
                                                <div className="row no-gutters align-items-center">
                                                    <div className="col-12 col-lg-6">
                                                        <div className="row no-gutters">
                                                            <div className="col-12 px-1 py-1">
                                                                <label>Nome do programa</label>
                                                                <input autoComplete="off" name="nomePrograma" className="form-control input-edicao" type="text" value={this.state.nomePrograma} onChange={this.handleOnChange} />
                                                            </div>
                                                            <div className="col-12 px-1 py-1">
                                                                <label>Descrição do programa</label>
                                                                <input autoComplete="off" name="descricaoPrograma" className="form-control input-edicao" type="text" value={this.state.descricaoPrograma} onChange={this.handleOnChange} />
                                                            </div>
                                                            <div className="col-12 px-1 py-1">
                                                                <label>Url para imagem de capa</label>
                                                                <input autoComplete="off" name="urlImagem" className="form-control input-edicao" type="text" value={this.state.urlImagem} onChange={this.handleOnChange} />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="col-12 col-lg-6">
                                                        <div className="row no-gutters">
                                                            <div className="col-12 py-1">
                                                                <div className="row no-gutters align-items-center">
                                                                    <div className="offset-2 col-8 text-center py-3">
                                                                        <div className="div-img-capa" style={{ backgroundImage: `url(${this.state.urlImagem})` }} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-12 col-lg-12 py-3 text-center text-lg-right">
                                                        {this.state.isLoadingPrograma ? (
                                                            <div className="spinner-border text-primary" role="status" />
                                                        ) : (
                                                            <>
                                                                {this.state.sucessoAlteracao && !this.state.temAlteracao && (
                                                                    <span className="text-success mr-3"><i>Alterações salvas com sucesso.</i></span>
                                                                )}
                                                                {this.state.temAlteracao && (
                                                                    <span className="text-danger mr-3"><i>As alterações ainda não foram salvas.</i></span>
                                                                )}
                                                                {this.state.permissaoEdicaoPodcast && (
                                                                    <button onClick={this.salvarPrograma} disabled={this.state.nomePrograma.trim() === '' || !this.state.temAlteracao} className="btn btn-outline-success">salvar alterações</button>
                                                                )}
                                                            </>
                                                        )}
                                                    </div>
                                                </div>
                                            </fieldset>

                                        </div>
                                    </div>
                                )}
                                <div className="row no-gutters">
                                    <div className="col-12 pt-4 pb-3 text-center">
                                        <h5 className="m-0">Lista de episódios</h5>
                                    </div>
                                    <div className="col-12">
                                        <div className="card">
                                            <div className="card-body">
                                                <div className="row no-gutters align-items-center pb-lg-3">
                                                    <div className="col-12 col-lg-4 py-lg-0 text-center text-lg-left">
                                                        <h6 className="m-0">Status: <span className={`badge badge-${this.state.infosPrograma.habilitado ? 'success' : 'secondary badge-opacity'}`}>{this.state.infosPrograma.habilitado ? "Habilitado" : "Desabilitado"}</span></h6>
                                                    </div>
                                                    {this.state.permissaoEdicaoPodcast && (
                                                        <div className="col-12 col-lg-4">
                                                            <div className="row no-gutters">
                                                                {this.state.infosPrograma.habilitado ? (
                                                                    <div className="col-12 py-3 py-lg-0 text-center">
                                                                        <button onClick={this.confirmaStatusPublicacao} className="btn btn-outline-danger">desabilitar programa</button>
                                                                    </div>
                                                                ) : (
                                                                    <div className="col-12 py-3 py-lg-0 text-center">
                                                                        <button onClick={this.confirmaStatusPublicacao} className="btn btn-outline-info">habilitar programa</button>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    )}
                                                    {this.state.permissaoEdicaoPodcast && (
                                                        <div className="col-12 col-lg-4 pb-3 py-lg-2 text-center">
                                                            <button onClick={this.novoEpisodio} className="btn btn-outline-success">novo episódio</button>
                                                        </div>
                                                    )}

                                                </div>
                                                {this.state.isLoadingEpisodios ? (
                                                    <div className="col-12 text-center px-3 py-5">
                                                        <div className="spinner-border text-primary" role="status" />
                                                    </div>
                                                ) : (
                                                    <div className="col-12">
                                                        <div className="row lista-episodios">
                                                            {!!this.state.listaEpisodios && this.state.listaEpisodios.map((item, index) => {
                                                                return (
                                                                    <div className="col-12 py-2" key={index}>
                                                                        <PodcastEpisodes
                                                                            item={item}
                                                                            mudaStatusEpisodio={this.mudaStatusEpisodio}
                                                                            history={this.props.history}
                                                                            match={this.props.match}
                                                                            permissaoEdicaoPodcast={this.state.permissaoEdicaoPodcast}
                                                                        />
                                                                    </div>
                                                                )
                                                            })}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    {!this.state.isLoadingEpisodios && this.state.listaEpisodios && this.state.listaEpisodios.length > 0 && (
                                        <div className="col-12 mt-2 px-0">
                                            <div className="paginacao-episodios">
                                                <Pagination onChange={this.onChangePage} current={this.state.pagina} total={this.state.paginasEpisodios * this.state.limite} pageSize={this.state.limite} />
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    )}
                </div>

                <Modal isOpen={this.state.modalStatusPublicacao} toggle={this.toggleStatusPublicacao}>
                    <ModalHeader toggle={this.toggleStatusPublicacao}>Mudança de Status do Programa</ModalHeader>
                    <ModalBody>
                        {!this.state.infosPrograma.habilitado ? (
                            <p className="m-0">{`Deseja confirmar a habilitação do programa ${this.state.nomePrograma}?`}</p>
                        ) : (
                            <p className="m-0">{`Deseja desabilitar o programa ${this.state.nomePrograma}?`}</p>
                        )}

                    </ModalBody>
                    <ModalFooter>
                        {this.state.isLoadingStatusPrograma ? (
                            <div className="spinner-border text-primary" role="status" />
                        ) : (
                            <Button disabled={this.state.isLoadingStatusPrograma} color={`${this.state.infosPrograma.habilitado ? `danger` : `success`}`} onClick={this.mudaStatusPrograma}>confirmar</Button>
                        )}
                        {' '}<Button color="secondary" onClick={() => this.setState({ modalStatusPublicacao: !this.state.modalStatusPublicacao })}>voltar</Button>
                    </ModalFooter>
                </Modal>

                <ErrorModal
                    isOpen={this.state.hasError}
                    message={this.state.errorMessage}
                    closeErrorModal={this.closeErrorModal}
                // direcionaURL={'/conteudo'}
                // goBack={true}
                />
                <ModalAlteracoes
                    isOpen={this.state.modalAlteracoes}
                    toggle={this.toggleModalAlteracoes}
                />
            </div >
        )
    }
}

export default PodcastProgramDetails;
